import { styled } from '@linaria/react';
import { inkDark, inkLight, skyBase } from '../../../../styles/design-tokens';
import { DataManagementDropShadowContainer } from '../data-management-header';

const GroupsContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  height: 100%;
  margin: 16px 0px 0px 0px;
`;

const GroupsContentContainer = styled(DataManagementDropShadowContainer)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const GroupsContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const GroupsContentHeaderActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const GroupSection = styled.div`
  margin-bottom: 16px;
`;

const GroupSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

const GroupSectionTitle = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${inkDark};
`;

const EmptyStateText = styled.p`
  color: ${inkLight};
  font-size: 14px;
  text-align: center;
  padding: 48px 0;
`;

const ModalDivider = styled.hr`
  border: none;
  border-top: 1px solid ${skyBase};
  margin: 10px 0;
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
`;

const ModalGroupSection = styled.div`
  margin-bottom: 16px;
`;

const ModalGroupTitle = styled.div`
  font-weight: 600;
  font-size: 13px;
  color: ${inkDark};
  margin-bottom: 8px;
`;

export {
  EmptyStateText,
  GroupSection,
  GroupSectionHeader,
  GroupSectionTitle,
  GroupsContainer,
  GroupsContentContainer,
  GroupsContentHeader,
  GroupsContentHeaderActions,
  ModalActions,
  ModalDivider,
  ModalGroupSection,
  ModalGroupTitle,
};
